import { useExportProductionSitesForBrands } from "~/gen/api"
import {
  downloadFile,
  resolveCsvFilename,
  toDownloadPayload,
} from "~/utils/downloadFile"

export const useExportProductionSitesForBrandsMutation = () =>
  useExportProductionSitesForBrands({
    client: { responseType: "blob" },
    mutation: {
      onSuccess: async (response) => {
        const filename = resolveCsvFilename(
          response.headers["content-disposition"],
          "production-sites.csv"
        )
        const payload = await toDownloadPayload(response.data)
        downloadFile(payload, filename, "text/csv")
      },
    },
  })
